/**
 * Country phone configuration for locale-based phone number formatting
 * Maps LocaleEnum values to country phone settings
 */

export const COUNTRY_PHONE_CONFIG = {
  ko: {
    code: 'ko',
    name: '한국',
    nameEn: 'Korea',
    dialCode: '+82',
    placeholder: '010-1234-5678',
    // Korean phone number pattern: 02-XXX-XXXX, 010-XXXX-XXXX, etc.
    formatPattern: /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
    formatReplacement: '$1-$2-$3',
  },
  zh: {
    code: 'zh',
    name: '중국',
    nameEn: 'China',
    dialCode: '+86',
    placeholder: '138-0000-0000',
    // Chinese phone number pattern: 3-4-4 format
    formatPattern: /(\d{3})(\d{4})(\d{4})/,
    formatReplacement: '$1-$2-$3',
  },
  en: {
    code: 'en',
    name: '미국',
    nameEn: 'USA',
    dialCode: '+1',
    placeholder: '(555) 123-4567',
    // US phone number pattern: (XXX) XXX-XXXX
    formatPattern: /(\d{3})(\d{3})(\d{4})/,
    formatReplacement: '($1) $2-$3',
  },
  ja: {
    code: 'ja',
    name: '일본',
    nameEn: 'Japan',
    dialCode: '+81',
    placeholder: '090-1234-5678',
    // Japanese phone number pattern: XXX-XXXX-XXXX
    formatPattern: /(\d{3})(\d{4})(\d{4})/,
    formatReplacement: '$1-$2-$3',
  },
  vi: {
    code: 'vi',
    name: '베트남',
    nameEn: 'Vietnam',
    dialCode: '+84',
    placeholder: '091-234-5678',
    // Vietnamese phone number pattern: XXX-XXX-XXXX
    formatPattern: /(\d{3})(\d{3})(\d{4})/,
    formatReplacement: '$1-$2-$3',
  },
};

// Default locale
export const DEFAULT_LOCALE = 'ko';

// Get country config by locale code
export const getCountryConfig = (locale) => {
  return COUNTRY_PHONE_CONFIG[locale] || COUNTRY_PHONE_CONFIG[DEFAULT_LOCALE];
};

// Get all country options for dropdown
export const getCountryOptions = () => {
  return Object.values(COUNTRY_PHONE_CONFIG).map((config) => ({
    value: config.code,
    label: `${config.name} (${config.dialCode})`,
    labelEn: `${config.nameEn} (${config.dialCode})`,
  }));
};
